/*
 * Search overlay — live results
 *
 * Ports the two-stage behaviour of the WordPress theme's search.js onto
 * Shopify's Predictive Search API:
 *
 *   STEP 1  typing debounces into a suggest call and lists matching search
 *           terms as hints in .search__overlay__hints
 *   STEP 2  picking a hint (or submitting the form) runs the same endpoint for
 *           products/collections/articles/pages and renders them into
 *           .search__overlay__results
 *
 * The endpoint is read through sections/taste-predictive-search.liquid rather
 * than /search/suggest.json, so items tagged in Theme settings > Search
 * behavior are filtered out server-side before they ever reach the browser.
 *
 * The markup written here matches the class contract in taste-shopify.css, and
 * the nav__search--* state classes are what drive the show/hide transitions.
 */
jQuery(document).ready(function ($) {


  // CONFIG — emitted by sections/header.liquid so strings stay translatable

  var config = {};
  try {
    config = JSON.parse($('#taste-search-config').text());
  } catch (e) {
    config = {};
  }

  var predictiveUrl = config.predictive_url || '/search/suggest';
  var searchUrl = config.search_url || '/search';
  var sectionId = 'taste-predictive-search';


  // ELEMENTS

  var $input    = $('.search__overlay__form .search__input');
  var $hints    = $('.search__overlay__hints');
  var $results  = $('.search__overlay__results');
  var $nav      = $('.nav__search');
  var $noResults = $('.search__no_results');
  var $moreLink = $('.search__overlay__more .taste_button--primary');

  if (!$input.length) return;


  // FUNCTIONS

  function escapeHtml(str) {
    return $('<div>').text(str == null ? '' : str).html();
  }

  function highlightMatch(text, query) {
    var idx = text.toLowerCase().indexOf(query.toLowerCase());
    if (idx === -1) return escapeHtml(text);
    return escapeHtml(text.slice(0, idx)) +
      '<mark>' + escapeHtml(text.slice(idx, idx + query.length)) + '</mark>' +
      escapeHtml(text.slice(idx + query.length));
  }

  function setState(state) {
    $nav
      .toggleClass('nav__search--has_hints',   state === 'hints')
      .toggleClass('nav__search--has_results', state === 'results')
      .toggleClass('nav__search--pending',     state === 'pending');
  }

  function showHints(matches, query) {
    if (!matches.length) {
      $hints.empty();
      setState('');
      return;
    }

    var html = matches.map(function (item) {
      return '<li class="search__overlay__hints__item">' +
        '<a href="#" data-value="' + escapeHtml(item) + '">' +
        '<span>' + highlightMatch(item, query) + '</span>' +
        '<svg width="24" height="24"><use xlink:href="#icon_search"></use></svg>' +
        '</a></li>';
    }).join('');

    $hints.html(html);
    setState('hints');
  }

  function showResults(results) {
    if (!results.length) {
      $results.empty();
      setState('');
      showNoResults();
      return;
    }

    hideNoResults();

    var html = '<ul class="search__overlay__results__list">' +
      results.map(function (item) {
        var thumb = item.thumbnail
          ? '<span class="search__overlay__results__thumbnail"><img src="' + escapeHtml(item.thumbnail) + '" alt="" loading="lazy" /></span>'
          : '';
        var itemClass = 'search__overlay__results__item' + (item.modifier ? ' search__overlay__results__item--' + escapeHtml(item.modifier) : '');
        return '<li class="' + itemClass + '">' +
          '<a href="' + escapeHtml(item.url) + '">' +
          thumb +
          '<span class="search__overlay__results__title">' + highlightMatch(item.title, currentQuery) + '</span>' +
          '<span class="search__overlay__results__type">' + escapeHtml(item.type) + '</span>' +
          '</a>' +
          '</li>';
      }).join('') +
      '</ul>';

    $results.html(html);
    $moreLink.attr('href', searchUrl + '?q=' + encodeURIComponent(currentQuery));
    setState('results');
  }

  function resetToSuggestions() {
    $hints.empty();
    $results.empty();
    $moreLink.attr('href', searchUrl);
    setState('');
    hideNoResults();
  }

  function showNoResults() {
    var message = (config.no_results || '').split('@@terms@@').join(escapeHtml(currentQuery));
    $noResults.find('.search__no_results__message').html('<p>' + message + '</p>');
    $nav.addClass('nav__search--no_results');
  }

  function hideNoResults() {
    $nav.removeClass('nav__search--no_results');
  }

  // The section comes back wrapped in Shopify's section div, so unwrap it, then
  // take the outermost {...} — that way any stray markup around the payload is
  // tolerated rather than breaking the whole overlay.
  function parsePayload(html) {
    var wrapper = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('shopify-section-' + sectionId);

    var text = wrapper ? wrapper.textContent : html;
    var start = text.indexOf('{');
    var end = text.lastIndexOf('}');

    if (start === -1 || end <= start) {
      throw new Error('taste-search: no JSON in the ' + sectionId + ' response');
    }

    return JSON.parse(text.slice(start, end + 1));
  }

  function suggest(query, types, limit) {
    return $.ajax({
      url: predictiveUrl,
      // Must be 'html': /search/suggest content-negotiates on Accept and only
      // renders the section for an HTML request — jQuery's 'text' dataType asks
      // for text/plain and gets a 404 back. The body is still handled as a
      // string; dataType only decides the Accept header and the converter.
      dataType: 'html',
      data: {
        q: query,
        section_id: sectionId,
        'resources[type]': types,
        'resources[limit]': limit,
        'resources[options][unavailable_products]': 'last',
      },
    }).then(parsePayload, function (xhr) {
      // Rethrow: returning here would resolve the promise with undefined and
      // surface as a confusing TypeError further down instead of the real cause.
      throw new Error(
        predictiveUrl + ' returned ' + xhr.status + ' — ' + (xhr.responseText || '').slice(0, 200)
      );
    });
  }

  // STEP 2: full lookup for a chosen term
  function runSearch(query) {
    $input.val(query);
    currentQuery = query;
    $hints.empty();
    setState('pending');

    suggest(query, 'product,collection,article,page', 10)
      .then(function (data) {
        if (currentQuery !== query) return;
        showResults(data.results || []);
      })
      .catch(function (error) {
        console.error('taste-search:', error);
        if (currentQuery !== query) return;
        showResults([]);
      });
  }


  // HINT TERMS
  //
  // The WP build filtered a prebuilt terms JSON. Shopify's nearest equivalent is
  // the `query` resource, but it is deliberately not used: those suggestions are
  // phrases derived from the catalogue rather than records, so a hide-from-search
  // product comes back as a suggested phrase with nothing to filter on. Hints are
  // the titles of the filtered results instead, so anything hidden stays hidden
  // at both stages.

  function hintsFrom(data) {
    var titles = [];
    (data.results || []).forEach(function (item) {
      if (titles.indexOf(item.title) === -1) titles.push(item.title);
    });

    return titles.slice(0, 8);
  }


  // EVENTS

  var debounceTimer = null;
  var currentQuery  = '';

  // STEP 1: Live autocomplete hints
  $input.on('input', function () {
    var query = $(this).val().trim();
    clearTimeout(debounceTimer);
    currentQuery = query;

    $results.empty();
    setState('');
    hideNoResults();

    if (!query) {
      resetToSuggestions();
      return;
    }

    debounceTimer = setTimeout(function () {
      suggest(query, 'product,collection,article,page', 8)
        .then(function (data) {
          if (currentQuery !== query) return;
          showHints(hintsFrom(data), query);
        })
        .catch(function (error) {
          console.error('taste-search:', error);
          if (currentQuery === query) showHints([], query);
        });
    }, 150);
  });

  // STEP 2: Clicking a hint runs a full search for that term
  $(document).on('click', '.search__overlay__hints__item a', function (e) {
    e.preventDefault();
    runSearch($(this).data('value'));
  });

  // STEP 2 (alt): Form submit — never navigate; run search or show no-results
  $(document).on('submit', '.search__overlay__form .search__form', function (e) {
    e.preventDefault();
    var query = $input.val().trim();
    if (!query) return;

    runSearch(query);
  });

  // Focus the input when the search overlay is opened
  $('.site__header__search_toggle, .nav__overlay__search_toggle').on('click', function () {
    setTimeout(function () {
      $input.focus();
    }, 300);
  });

  // Reset state when overlay is closed
  $('.search__overlay__close').on('click', function () {
    setTimeout(resetToSuggestions, 300);
    $input.val('');
    currentQuery = '';
  });


  // INIT

  resetToSuggestions();


});
